<template>
  <div class="person">
    <div class="person-con">
      <div class="head-con">
        <img :src="userInfo && userInfo.headPicUrl" class="head-cover" alt="">
        <div class="head-info">
          <div class="txt1">
            {{ userInfo && userInfo.realName }}
            <img src="../../assets/images/person/veeva-success.png" v-if="curVeevaStatus === 'success'" alt="">
            <img src="../../assets/images/person/veeva-fail.png" alt="" v-if="curVeevaStatus === 'fail'">
            <img src="../../assets/images/person/veeva-pedding.png" alt="" v-if="curVeevaStatus === 'pedding'">
          </div>
          <div class="txt2">{{ userInfo && userInfo.hospitalName }}</div>
          <div class="txt3" @click="handleJump('integral')">
            <img src="@/assets/images/training/img(34).png" class="icon1" alt="">
            <span class="integ-txt">{{ integral > 0 ? integral : 0 }}</span>
            积分
            <img src="@/assets/images/training/img(35).png" class="icon2" alt="">
          </div>
        </div>
        <div class="head-icons">
          <div class="head-identity" v-if="shouldShowIdentity" v-track="{ functionName: '身份码' }" @click="handleShowIdentity">
            <svg class="icon-identity" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2" y="2" width="8" height="8" stroke="currentColor" stroke-width="1.5" fill="none"/>
              <rect x="14" y="2" width="8" height="8" stroke="currentColor" stroke-width="1.5" fill="none"/>
              <rect x="2" y="14" width="8" height="8" stroke="currentColor" stroke-width="1.5" fill="none"/>
              <rect x="14" y="14" width="8" height="8" stroke="currentColor" stroke-width="1.5" fill="none"/>
              <rect x="4" y="4" width="4" height="4" fill="currentColor"/>
              <rect x="16" y="4" width="4" height="4" fill="currentColor"/>
              <rect x="4" y="16" width="4" height="4" fill="currentColor"/>
              <rect x="16" y="16" width="4" height="4" fill="currentColor"/>
            </svg>
            <div class="identity-txt">身份码</div>
          </div>
          <div class="head-sao" v-track="{ functionName: '扫一扫' }" @click="handleClick">
            <img src="@/assets/images/person/me_icon_Scan@2x.png" class="icon-sao" alt="">
            <div class="sao-txt">扫一扫</div>
          </div>
        </div>
      </div>
      <div class="flex-integral">
        <div class="flex-left" @click="handleJump('medal')" v-if="medalList && medalList.length > 0">
          <img src="@/assets/images/training/img(47).png" class="img-medal-title" alt="">
          <template v-for="(item, index) in medalList">
            <img :key="index" v-if="`${item.medalLevel}` === '1'" src="@/assets/images/training/img(13).png"
                 class="icon-medal" alt="">
            <img :key="index" v-if="`${item.medalLevel}` === '2'" src="@/assets/images/training/img(16).png"
                 class="icon-medal" alt="">
            <img :key="index" v-if="`${item.medalLevel}` === '3'" src="@/assets/images/training/img(12).png"
                 class="icon-medal" alt="">
            <img :key="index" v-if="`${item.medalLevel}` === '4'" src="@/assets/images/training/img(15).png"
                 class="icon-medal" alt="">
            <img :key="index" v-if="`${item.medalLevel}` === '5'" src="@/assets/images/training/img(14).png"
                 class="icon-medal" alt="">
            <img :key="index" v-if="`${item.medalLevel}` === '2025'" src="@/assets/images/training/img(60).png"
                 class="icon-medal" alt="">
          </template>
          <img src="@/assets/images/training/img(4).png" class="icon-arrow" alt="">
        </div>
        <div class="flex-left" @click="handleJump('medal')" v-else>
          <img src="@/assets/images/training/img(47).png" class="img-medal-title" alt="">
          <span class="flex-txt-none">暂无勋章</span>
          <!-- <img src="@/assets/images/training/img(4).png" class="icon-arrow" alt=""> -->
        </div>
        <div class="flex-left" v-track="{ functionName: '学习报告查看' }" @click="handleJump('studyReport')">
          <img src="@/assets/images/training/img(32).png" class="icon-study" alt="">
          <span class="flex-txt">专属的学习报告</span>
          <img src="@/assets/images/training/img(4).png" class="icon-arrow" alt="">
        </div>
      </div>
      <div class="report-div">
        <!-- <div class="report-top">
          <img src="@/assets/images/person/me_studey_bg@2x.png" class="top-img-bg" alt="">
          <div class="top-left">
            <img src="@/assets/images/person/me_image@2x.png" class="icon-left" alt="">
            <div class="left-txt">专属的学习报告</div>
          </div>
          <div class="top-right" v-track="{ functionName: '学习报告查看' }" @click="handleJump('studyReport')">去查看</div>
        </div> -->
        <div class="flex-div">
          <div class="flex-item">
            <div class="item-txt1">{{ details.studyCourseNumber ? details.studyCourseNumber : 0 }}</div>
            <div class="item-txt2">学习课程</div>
          </div>
          <div class="flex-item">
            <div class="item-txt1">{{ details.joinLiveNumber ? details.joinLiveNumber : 0 }}</div>
            <div class="item-txt2">参加直播</div>
          </div>
          <div class="flex-item">
            <div class="item-txt1">{{ details.uploadCaseNumber ? details.uploadCaseNumber : 0 }}</div>
            <div class="item-txt2">上传病例</div>
          </div>
          <div class="flex-item">
            <div class="item-txt1">{{ details.studyCourseHourNumber ? details.studyCourseHourNumber : 0 }}</div>
            <div class="item-txt2">学习时长</div>
          </div>
        </div>
      </div>
      <div class="flex-nav-block">
        <div class="nav-item" v-track="{ functionName: '我的病例' }" @click="handleJump('bingli')">
          <img src="@/assets/images/person/me_icon_illness@2x.png" class="nav-item-icon" alt="">
          <div class="nav-item-txt">我的病例</div>
        </div>
        <div class="nav-item" v-track="{ functionName: '直播报名' }" @click="handleJump('zhibo')">
          <img src="@/assets/images/person/me_icon_video@2x.png" class="nav-item-icon" alt="">
          <div class="nav-item-txt">直播报名</div>
        </div>
        <div class="nav-item" v-track="{ functionName: '内容收藏' }" @click="handleJump('shoucang')">
          <img src="@/assets/images/person/me_icon_collect@2x.png" class="nav-item-icon" alt="">
          <div class="nav-item-txt">内容收藏</div>
        </div>
        <div class="nav-item" v-track="{ functionName: '资料修改' }" @click="handleJump('xiugai')">
          <img src="@/assets/images/person/me_icon_modify@2x.png" class="nav-item-icon" alt="">
          <div class="nav-item-txt">资料修改</div>
        </div>
        <div class="nav-item" v-track="{ functionName: '兴趣修改' }" @click="handleJump('interest')">
          <img src="@/assets/images/person/me_icon_hobby@2x.png" class="nav-item-icon" alt="">
          <div class="nav-item-txt">兴趣修改</div>
        </div>
        <div class="nav-item" v-track="{ functionName: '用户授权' }" @click="handleJump('yonghushouquan')">
          <img src="@/assets/images/person/me_icon_agreement@2x.png" class="nav-item-icon" alt="">
          <div class="nav-item-txt">用户授权</div>
        </div>
        <div class="nav-item" v-track="{ functionName: '浏览历史' }" @click="handleJump('lishi')">
          <img src="@/assets/images/person/me_icon_history@2x.png" class="nav-item-icon" alt="">
          <div class="nav-item-txt">浏览历史</div>
        </div>
        <div class="nav-item" v-track="{ functionName: '意见反馈' }" @click="handleJump('helpCenter')">
          <img src="@/assets/images/person/me_icon_column@2x.png" class="nav-item-icon" alt="">
          <div class="nav-item-txt">意见反馈</div>
        </div>
      </div>

      <div class="item-href" v-track="{ functionName: 'mini ice' }" @click="handleJump('mini')">
        <img src="@/assets/images/person/me_icon_ice@2x.png" class="href-icon" alt="">
        <div class="href-txt mini">mini ice</div>
        <img src="@/assets/images/questionBank/img(5).png" class="icon-right" alt="">
      </div>

      <div class="item-href" v-track="{ functionName: '我的消息' }" @click="handleJump('xiaoxi')">
        <img src="@/assets/images/person/me_icon_new@2x.png" class="href-icon" alt="">
        <div class="href-txt">我的消息</div>
        <img src="@/assets/images/person/right3.png" class="icon-right" alt="">
      </div>
      <div class="item-href" v-track="{ functionName: '我的帖子' }" @click="handleJump('dcc')">
        <img src="@/assets/student/dcc.png" class="href-icon" alt="">
        <div class="href-txt">我的帖子</div>
        <img src="@/assets/images/person/right3.png" class="icon-right" alt="">
      </div>
      <div class="item-href" v-track="{ functionName: '我的点赞' }" @click="handleJump('zang')">
        <img src="@/assets/images/person/me_icon_like@2x.png" class="href-icon" alt="">
        <div class="href-txt">我的点赞</div>
        <img src="@/assets/images/person/right3.png" class="icon-right" alt="">
      </div>
      <div class="item-href" v-track="{ functionName: '我的评论' }" @click="handleJump('pinglun')">
        <img src="@/assets/images/person/me_icon_comment@2x.png" class="href-icon" alt="">
        <div class="href-txt">我的评论</div>
        <img src="../../assets/images/person/right3.png" class="icon-right" alt="">
      </div>
      <div class="item-href" v-track="{ functionName: '设置' }" @click="handleJump('shezhi')">
        <img src="@/assets/images/person/me_icon_teaching@2x.png" class="href-icon" alt="">
        <div class="href-txt">设置</div>
        <img src="@/assets/images/person/right3.png" class="icon-right" alt="">
      </div>
      <!-- <div class="item-href" v-if="userInfo.memberType + '' === '0'" v-track="{ functionName: '远程带教授权' }"
        @click="handleJump('yuancheng')">
        <img src="@/assets/images/person/me_icon_teaching@2x.png" class="href-icon" alt="">
        <div class="href-txt">远程带教授权</div>
        <img src="@/assets/images/person/right3.png" class="icon-right" alt="">
      </div> -->
      <!-- <div class="item-href" v-track="{ functionName: '提醒设置' }" @click="handleJump('set')">
        <img src="@/assets/images/person/set@2x.png" class="href-icon" alt="">
        <div class="href-txt">提醒设置</div>
        <img src="@/assets/images/person/right3.png" class="icon-right" alt="">
      </div> -->
      <!-- <div class="item-href" v-track="{functionName: '意见反馈'}" @click="handleJump('helpCenter')">
        <img src="@/assets/images/person/me_icon_help@2x.png" class="href-icon" alt="">
        <div class="href-txt">意见反馈</div>
        <img src="@/assets/images/person/right3.png" class="icon-right" alt="">
      </div> -->
    </div>
    <barComponents></barComponents>
    <van-overlay :show="isLoginPc">
      <div class="wrap">
        <img src="@/assets/images/person/loginPC.png" class="img-wrap" alt="" v-if="loginPcDefault">
        <div class="wrap-txt">{{ loginPcOverlayMsg }}</div>
        <div class="warp-btn">
          <div class="btn btn1" @click="cancelLoginPC">取消</div>
          <div class="btn btn2" @click="handleLoginPC">登录</div>
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="isRemote" @click="isRemote = false">
      <div class="wrap" @click.stop>
        <div class="wrap-txt">应用授权</div>
        <div class="wrap-con">
          远程带教系统将获取您iEP上的基本信息,用于进行身份验证。
          <br/>
          <br/>
          您可阅读
          <span class="href-txt" @click="handleJump('singlePage')">《Carto远程服务协议》</span>
          了解详细信息。如您同意，请点击“同意授权”进行授权。
        </div>
        <div class="warp-btn">
          <div class="btn btn1" @click="isRemote = false">取消</div>
          <div class="btn btn2" @click="isHospital = true; isRemote = false">同意授权</div>
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="isHospital" @click="isHospital = false">
      <div class="wrap" @click.stop>
        <div class="wrap-txt">确认信息</div>
        <div class="wrap-con">
          <div class="wrap-txt wrap-txt2">授权医院：{{ userInfo && userInfo.hospitalName }}</div>
          <div class="wrap-txt3">如信息有误，可点击修改</div>
        </div>
        <div class="warp-btn">
          <div class="btn btn1" @click="isHospital = false">取消</div>
          <div class="btn btn2" @click="handleRemote">确定</div>
        </div>
      </div>
    </van-overlay>
    <medalOverlay ref="medal"></medalOverlay>
    <van-overlay :show="isShowIdentity" :duration="0" @click="isShowIdentity = false">
      <div class="wrap identity-wrap" @click.stop>
        <div class="wrap-txt">身份码</div>
        <div class="qrcode-container">
          <div id="qrcode" class="qrcode"></div>
        </div>
        <div class="identity-tip">请您妥善保管您的身份码，勿将身份码借由他人使用</div>
        <div class="warp-btn">
          <div class="btn btn2" @click="isShowIdentity = false">关闭</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
// import { wechatShare } from '@/api/wxshare.js'
import wx from 'weixin-js-sdk'
import QRCode from 'qrcode'
import barComponents from '../../components/barComponents.vue'
import {getUserIdentity, setSha, traceClickURL, veevaStatusFail, veevaStatusSuccess} from '../../utils/util'
import {
  loginPc,
  addUserhospauth,
  getUserMedal,
  getUserCostTotal,
  getAuthStatus,
  loginSimulator,
  loginSmart
} from '../../api/person'
import { getLearningReport, getQrCode, dictionaryList } from '../../api/api'
import { getUsersRole } from '../../api/cartoJourney'
import medalOverlay from './components/medalOverlay.vue'
import withRouteTracking from '@/utils/withRouteTracking'
import {Toast} from 'vant'
import {
  isAnnualReportLive
} from '@/utils/annualReport'

const UserProfile = {
  components: {
    barComponents,
    medalOverlay
  },
  data() {
    return {
      details: {},
      isLoginPc: false,
      isRemote: false,
      boolRemote: 0,
      isHospital: false,
      medalList: [],
      integral: 0,
      loginPcDefault: true,
      loginPcOverlayMsg: 'iEP网页端登录确认',
      userIdentity: getUserIdentity(),
      annualReportReady: false,
      isShowIdentity: false,
      userRoles: [],
      identityCodePeList: []
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    curVeevaStatus() {
      if (!this.userIdentity.veevaStatus) return ''
      if (veevaStatusSuccess.includes(this.userIdentity.veevaStatus)) {
        return 'success'
      } else if (veevaStatusFail.includes(this.userIdentity.veevaStatus)) {
        return 'fail'
      } else {
        return 'pedding'
      }
    },
    shouldShowIdentity() {
      if (!this.userInfo) return false
      const memberType = `${this.userInfo.memberType}` === '1'
      const hasRole = this.userRoles.some(role => this.identityCodePeList.includes(role))
      return memberType && hasRole
    }
  },
  watch: {
    isRemote(newval, oldval) {
      localStorage.setItem('isRemote', newval)
    }
  },
  async mounted() {
    this.annualReportReady = await isAnnualReportLive()
    this.isRemote = JSON.parse(localStorage.getItem('isRemote'))
    getLearningReport({openId: this.userInfo.iepOpenId}).then(res => {
      if (!res.data) return
      this.details = res.data
    })
    try {
      let {code, data} = await dictionaryList({
        typeCode: 'IDENTITY_CODE_PE_LIST',
        dataStatus: '1'
      })
      if (code === 0) {
        this.identityCodePeList = (JSON.parse(data[0].explainContent) || [])
      }
    } catch (err) {
      console.error('获取身份码角色列表失败:', err)
    }
    // 获取用户角色信息
    getUsersRole({userId: this.userInfo.id}).then(res => {
      const roles = res.data || ''
      this.userRoles = roles ? roles.split(',') : []
    }).catch(err => {
      console.error('获取用户角色失败:', err)
    })
    this.handleFun()
  },
  destroyed() {
    // sessionStorage.removeItem('WxCodeUrl')
  },
  methods: {
    handleFun() {
      // 获取用户是否授权远程带教
      getAuthStatus({
        userId: this.userInfo.id
      }).then(res => {
        this.boolRemote = res.data
      })
      getUserMedal({userId: this.userInfo.id}).then(res => {
        this.medalList = res.data
      })
      getUserCostTotal({
        userId: this.userInfo.id
      }).then(res => {
        this.integral = res.data
      })
    },
    // 同意授权远程
    handleRemote() {
      addUserhospauth({
        hospital: this.userInfo.hospitalName,
        hospitalCustCd: this.userInfo.hospitalId,
        veevaMultiCode: this.userInfo.multiCode,
        authStatus: 1,
        userId: this.userInfo.id,
      }).then(res => {
        this.handleFun()
        this.$router.push({
          path: '/distanceEducation',
        })
      })
    },
    handleJump(type) {
      let openid = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      // let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      let iepTxt = `&nickname=123&avatar=123&subscribe=1`
      switch (type) {
        case 'medal':
          this.$router.push({
            path: '/myMedal'
          })
          break
        case 'integral':
          this.$router.push({
            path: '/integral'
          })
          break
        case 'bingli':
          setTimeout(() => {
            traceClickURL()
          })
          localStorage.setItem('functionUrl', `${process.env.bingliUrl}/wap/index.html#/mycase?index=1${openid}`)
          window.location.href = `${process.env.bingliUrl}/wap/index.html#/mycase?index=1${openid}`
          break
        case 'langmu':
          setTimeout(() => {
            traceClickURL()
          })
          localStorage.setItem('functionUrl', `${process.env.iepUrl}/mobile/user/book?appid=wxe25648d9b23e8779&redire${openid}${iepTxt}`)
          window.location.href = `${process.env.iepUrl}/mobile/user/book?appid=wxe25648d9b23e8779&redire${openid}${iepTxt}`
          break
        case 'zhibo':
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/newLiveList`)
          this.$router.push({
            path: '/newLiveList',
          })
          // setTimeout(() => { traceClickURL() })
          // localStorage.setItem('functionUrl', `${process.env.iepUrl}/mobile/user-live?appid=wxe25648d9b23e8779&redire${openid}${iepTxt}`)
          // window.location.href = `${process.env.iepUrl}/mobile/user-live?appid=wxe25648d9b23e8779&redire${openid}${iepTxt}`
          break
        case 'shoucang':
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/myCollect`)
          this.$router.push({
            path: '/collect'
          })
          // localStorage.setItem('functionUrl', `${process.env.iepUrl}/mobile/user-collect?appid=wxe25648d9b23e8779&redire${openid}${iepTxt}`)
          // window.location.href = `${process.env.iepUrl}/mobile/user-collect?appid=wxe25648d9b23e8779&redire${openid}${iepTxt}`
          break
        case 'xiugai':
          if (`${this.userInfo.memberType}` !== '0') {
            this.$toast('医生身份才能修改资料')
            return
          }
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/register`)
          this.$router.push({
            path: '/register',
            query: {
              isEidt: true,
              userAuth: 'my',
              // openId: this.userInfo.iepOpenId
            }
          })
          // setTimeout(() => { traceClickURL() })
          // localStorage.setItem('functionUrl', `${process.env.iepUrl}/mobile/user/info?appid=wxe25648d9b23e8779&redire${openid}${iepTxt}`)
          // window.location.href = `${process.env.iepUrl}/mobile/user/info?appid=wxe25648d9b23e8779&redire${openid}${iepTxt}`
          break
        case 'yonghushouquan':
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/agreeList`)
          this.$router.push({
            path: '/agreeList',
          })
          // setTimeout(() => { traceClickURL() })
          // localStorage.setItem('functionUrl', `${process.env.iepUrl}/mobile/user/agree?type=power&ys=1&appid=wxe25648d9b23e8779&redire${openid}${iepTxt}`)
          // window.location.href = `${process.env.iepUrl}/mobile/user/agree?type=power&ys=1&appid=wxe25648d9b23e8779&redire${openid}${iepTxt}`
          break
        case 'lishi':
          // window.location.href = `${process.env.iepUrl}/mobile/user-history?appid=wxe25648d9b23e8779&redire${openid}${iepTxt}`
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/browsHistory`)
          this.$router.push({
            path: '/browsHistory'
          })
          break
        case 'xiaoxi':
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/message`)
          this.$router.push({
            path: '/message'
          })
          // window.location.href = `${process.env.bingliUrl}/wap/index.html#/mymessage${openid}`
          break
        case 'dcc' :
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/dcc`)
          this.$router.push({
            path: '/dcc'
          })
          break
        case 'zang':
          // openidBindli = `?unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
          // localStorage.setItem('functionUrl', `${process.env.bingliUrl}/wap/index.html#/mylike${openidBindli}`)
          // window.location.href = `${process.env.bingliUrl}/wap/index.html#/mylike${openidBindli}`
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/my_like`)
          this.$router.push({
            path: '/my_like'
          })
          break
        case 'pinglun':
          // openidBindli = `?unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
          // localStorage.setItem('functionUrl', `${process.env.bingliUrl}/wap/index.html#/mycomment${openidBindli}`)
          // window.location.href = `${process.env.bingliUrl}/wap/index.html#/mycomment${openidBindli}`
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/my_comment`)
          this.$router.push({
            path: '/my_comment'
          })
          break
        case 'shezhi':
          // openidBindli = `?unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
          // localStorage.setItem('functionUrl', `${process.env.bingliUrl}/wap/index.html#/mycomment${openidBindli}`)
          // window.location.href = `${process.env.bingliUrl}/wap/index.html#/mycomment${openidBindli}`
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/config`)
          this.$router.push({
            path: '/config'
          })
          break
        case 'yuancheng': // 远程带教授权
          if (this.boolRemote) {
            setTimeout(() => {
              traceClickURL()
            })
            localStorage.setItem('functionUrl', `${process.env.iepUrl}/mobile/teauthManageaching?appid=wxe25648d9b23e8779&redire&t=1694594853679${openid}${iepTxt}`)
            // window.location.href = `${process.env.iepUrl}/mobile/teauthManageaching?appid=wxe25648d9b23e8779&redire&t=1694594853679${openid}${iepTxt}`
            this.$router.push({
              path: '/distanceEducation'
            })
          } else {
            this.isRemote = true
          }
          break
        case 'interest':
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/person/editInterest`)
          this.$router.push({
            path: '/person/editInterest'
          })
          break
        case 'helpCenter':
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/helpCenter`)
          this.$router.push({
            path: '/helpCenter'
          })
          break
        case 'studyReport':
          if (this.annualReportReady) {
            const entrance = '103'
            this.$router.push({
              path: '/annualReport',
              query: {
                entrance,
                channel: entrance
              }
            })
          } else {
            localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/studyReport`)
            this.$router.push({
              path: '/studyReport'
            })
          }
          break
        case 'singlePage':
          this.$router.push({
            path: '/singlePage'
          })
          break
        case 'set':
          this.$router.push({
            path: '/setDailyRemid'
          })
          break
        case 'mini':
          // sessionStorage.removeItem('iepLoginResult')
          const functionUrl = `${process.env.miniiceUrl}/api/user?openid=${this.userInfo.iepOpenId}&channel=4`
          localStorage.setItem('functionUrl', functionUrl)
          window.location.href = `${functionUrl}`
          break
        default:
          break
      }
    },
    handleShowIdentity() {
      const email = this.userInfo.email || ''
      const employeeId = this.userInfo.employeeId || ''
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

      if (!email || !emailRegex.test(email)) {
        Toast('邮箱格式不正确，请先完善个人信息')
        return
      }

      if (!employeeId) {
        Toast('员工ID信息不完整')
        return
      }

      this.isShowIdentity = true
      this.$nextTick(() => {
        this.generateIdentityQrCode()
      })
    },
    generateIdentityQrCode() {
      const email = this.userInfo.email || ''
      const employeeId = this.userInfo.employeeId || ''
      const qrCodeData = JSON.stringify({
        empGuid: employeeId,
        empEmail: email.split('@')[0]
      })

      const qrcodeElement = document.getElementById('qrcode')
      if (qrcodeElement) {
        qrcodeElement.innerHTML = ''
        const canvas = document.createElement('canvas')
        QRCode.toCanvas(canvas, qrCodeData, {
          width: 200,
          margin: 0,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        }, function (error) {
          if (error) {
            console.error(error)
          } else {
            qrcodeElement.appendChild(canvas)
          }
        })
      }
    },
    handleClick() {
      let $this = this
      localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/person`)
      wx.ready(function () {
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
          success: function (res) {
            if (res.resultStr.indexOf('/evaluateonepage') > -1) {
              $this.$router.push({
                path: `/evaluateonepage?${res.resultStr.split('?')[1]}`
              })
            } else if (res.resultStr.indexOf('/simulator/poster') > -1) {
              $this.$router.push({
                path: `/simulator/poster?${res.resultStr.split('?')[1]}`
              })
            } else {
              var result = JSON.parse(res.resultStr) // 当needResult 为 1 时，扫码返回的结果
              $this.loginPCResult = result
              $this.isLoginPc = true
              if ($this.loginPCResult.schema === 'cartoSmart') {
                $this.loginPcDefault = false
                $this.loginPcOverlayMsg = '您正在进行Cartosmart添加用户操作，请确认是否继续?'
                return
              }
              if ($this.loginPCResult.schema === 'cartojourney') {
                $this.loginPcDefault = true
                $this.loginPcOverlayMsg = 'iEP网页端登录确认'
                getQrCode({
                  random: $this.loginPCResult.random,
                  status: 'scan'
                })
              }
            }
          }
        })
        // 分享给朋友
      })
    },
    cancelLoginPC() {
      this.isLoginPc = false
      getQrCode({
        random: this.loginPCResult.random,
        status: 'cancel'
      })
    },
    async handleLoginPC() {
      this.isLoginPc = false
      const params = {
        'openid': this.userInfo.iepOpenId, // 'o3Jny6MA7rqtBoW8zm0_75DbDnOs',
        'qr': {
          'random': this.loginPCResult.random,
          'ts': this.loginPCResult.ts,
          'schema': this.loginPCResult.schema
        }
      }
      if (this.loginPCResult.schema === 'cartojourney-kong-dao') {
        await loginSimulator(params)
      } else if (this.loginPCResult.schema === 'cartoSmart') {
        try {
          const loginSmartRes = await loginSmart({
            sessionId: this.loginPCResult.sessionId,
            userId: this.userInfo.id,
          })
          if (loginSmartRes.code === 0) {
            Toast('操作成功')
          } else {
            throw new Error(loginSmartRes.msg)
          }
        } catch (e) {
          Toast(e)
        }
      } else {
        await getQrCode({
          random: this.loginPCResult.random,
          status: 'confirm'
        })
        await loginPc(params)
      }
    }
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.person {
  width: 100%;
  min-height: 100vh;
  background: #F9F8F7;
  padding-bottom: 60px;
  box-sizing: border-box;

  .loginout {
    width: 78px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    border: 1px solid #D2D3D9;
    border-radius: 100px;
    font-size: 12px;
    color: #BEC0C7;
    position: relative;
    margin-left: 50%;
    transform: translateX(-50%);
  }

  .img-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    top: -20px;
  }

  .person-con {
    position: relative;
    padding: 20px 16px;
    box-sizing: border-box;

    .head-con {
      display: flex;
      align-items: center;
      margin-bottom: 8px;

      .head-cover {
        width: 55px;
        height: 55px;
        border-radius: 50%;
        margin-right: 10px;
        display: block;
      }

      .head-info {
        flex: 1;
        margin-right: 10px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .txt1 {
          font-size: 16px;
          padding-top: 6px;
          box-sizing: border-box;
          font-weight: 600;
          line-height: 20px;
          margin-bottom: 4px;
          display: flex;
          align-items: center;
          img {
            width: 30px;
            margin-left: 5px;
          }
        }

        .txt2 {
          font-size: 12px;
          color: #7D7D7D;
          font-weight: 400;
          line-height: 20px;
        }

        .txt3 {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 82px;
          font-size: 12px;
          padding: 3px;
          color: #000000;
          box-sizing: border-box;
          border: 0.5px solid rgb(255, 255, 255);
          border-radius: 20px;
          background: rgba(213, 207, 201, 0.44);

          .integ-txt {
            color: #EB1700;
            display: flex;
            margin-right: 2px;
          }

          .icon1 {
            width: 14px;
            height: 14px;
            display: block;
            margin-right: 2px;
          }

          .icon2 {
            width: 6px;
            display: block;
            margin-left: 4px;
          }
        }
      }

      .head-icons {
        display: flex;
        gap: 10px;
        align-items: center;

        .head-identity {
          display: flex;
          flex-direction: column;
          align-items: center;

          .icon-identity {
            width: 18px;
            height: 18px;
            margin-bottom: 3px;
            display: block;
            color: #000000;
          }

          .identity-txt {
            font-size: 12px;
            color: #000000;
            line-height: 20px;
          }
        }

        .head-sao {
          display: flex;
          flex-direction: column;
          align-items: center;

          .icon-sao {
            width: 18px;
            height: 18px;
            margin-bottom: 3px;
            display: block;
          }

          .sao-txt {
            font-size: 12px;
            color: #000000;
            line-height: 20px;
          }
        }
      }
    }

    .flex-integral {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;

      .flex-left {
        display: flex;
        align-items: center;

        .flex-txt-none {
          font-size: 13px;
          color: #6A737E;
          margin-right: 4px;
        }

        .img-medal-title {
          width: 26px;
          display: block;
          margin-right: 4px;
        }

        .icon-medal {
          width: 23px;
          margin-right: 3px;
          display: block;
        }

        .icon-arrow {
          width: 12px;
          display: block;
        }

        .icon-study {
          width: 15px;
          display: block;
          margin-right: 4px;
        }

        .flex-txt {
          font-size: 13px;
          color: #000000;
          font-weight: 500;
          margin-right: 3px;
        }
      }
    }

    .report-div {
      width: 100%;
      height: 80px;
      border-radius: 12px;
      background-color: #fff;

      .report-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 43px;
        padding: 0 14px;
        box-sizing: border-box;
        position: relative;

        .top-img-bg {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
        }

        .top-left {
          display: flex;
          align-items: center;
          position: relative;

          .icon-left {
            width: 21px;
            height: 21px;
            display: block;
            margin-right: 4px;
          }

          .left-txt {
            font-size: 13px;
            color: #000000;
            font-weight: 500;
          }
        }

        .top-right {
          background-color: #EB1700;
          border-radius: 100px;
          text-align: center;
          line-height: 21px;
          height: 21px;
          width: 54px;
          font-size: 12px;
          color: #FFFFFF;
          position: relative;
        }
      }

      .flex-div {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .flex-item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 80px;
          width: 25%;

          .item-txt1 {
            font-size: 18px;
            color: #000000;
            font-weight: bold;
            line-height: 20px;
            margin-bottom: 4px;
          }

          .item-txt2 {
            font-size: 12px;
            color: #6A7481;
            line-height: 20px;
          }
        }
      }
    }

    .flex-nav-block {
      display: flex;
      background-color: #fff;
      flex-wrap: wrap;
      border-radius: 12px;
      box-sizing: border-box;
      margin-top: 8px;
      padding-top: 20px;
      padding-bottom: 5px;

      .nav-item {
        display: flex;
        flex-direction: column;
        width: 25%;
        align-items: center;
        justify-content: center;

        .nav-item-icon {
          width: 33px;
          height: 33px;
          margin-bottom: 4px;
          display: block;
        }

        .nav-item-txt {
          font-size: 13px;
          color: #212226;
          line-height: 20px;
          margin-bottom: 15px;
        }
      }
    }

    .item-href {
      margin-top: 8px;
      height: 52px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #fff;
      border-radius: 12px;
      box-shadow: 0px 15px 30px 0px rgba(245, 248, 252, 0.25);
      padding: 0 14px;
      box-sizing: border-box;

      .href-icon {
        width: 23px;
        height: 23px;
        display: block;
      }

      .href-txt {
        flex: 1;
        margin-left: 11px;
        font-size: 13px;
        color: #212226;

        &.mini {
          color: #EB1700;
          font-weight: 500;
        }
      }

      .icon-right {
        width: 13px;
        height: 13px;
        display: block;
      }
    }
  }

  /deep/ .van-overlay {
    z-index: 9999;

    .wrap {
      width: 320px;
      border-radius: 10px;
      background-color: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 20px;
      box-sizing: border-box;

      .img-wrap {
        width: 80px;
        display: block;
        margin-bottom: 18px;
        margin-left: 50%;
        transform: translateX(-50%);
      }

      .wrap-txt {
        font-size: 17px;
        line-height: 24px;
        font-weight: 500;
        color: #000000;
        margin-bottom: 30px;
        text-align: center;

        &.wrap-txt2 {
          border-bottom: 1px solid #A9AEB6;
          padding-bottom: 10px;
          box-sizing: border-box;
          text-align: left;
          margin-bottom: 14px;
        }
      }

      .wrap-txt3 {
        position: relative;

        &::before {
          content: '*';
          font-size: 17px;
          color: #FF0000;
          width: 9px;
          text-align: center;
          display: inline-block;
        }
      }

      .wrap-con {
        color: rgb(0, 0, 0);
        font-family: PingFang SC;
        font-size: 17px;
        font-weight: 300;
        line-height: 23.8px;
        letter-spacing: 0px;
        text-align: center;
        margin: 26px 0;

        .href-txt {
          color: #EB1700;
        }
      }

      .warp-btn {
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 8px;
        height: 55px;
        box-sizing: border-box;

        .btn {
          text-align: center;
          font-size: 17px;
          font-weight: 500;
          border-radius: 30pc;
          height: 42px;
          line-height: 42px;

          &.btn1 {
            color: #81766F;
            background: #F1EFED;
          }

          &.btn2 {
            background: #EB1700;
            color: #fff;
          }
        }
      }

      &.identity-wrap {
        .warp-btn {
          grid-template-columns: 1fr;
        }

        .qrcode-container {
          display: flex;
          justify-content: center;
          margin: 20px 0;

          #qrcode {
            display: flex;
            justify-content: center;
            align-items: center;

            canvas {
              width: 200px !important;
              height: 200px !important;
              image-rendering: pixelated;
            }
          }
        }

        .identity-tip {
          font-size: 12px;
          color: #666666;
          text-align: center;
          margin-bottom: 20px;
          line-height: 18px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/person/index.vue